<template>
  <v-app-bar
    app
    clipped-left
    :style="{ backgroundColor: color }"
    :dark="isThemeDark"
    elevation="0"
    outlined
  >
    <!-- Burger mobile -->
    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      icon
      @click="onMenuClicked"
      class="mr-2"
      :title="$t('Menu')"
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <!-- Logo (desktop uniquement) -->
    <v-img
      v-if="!$vuetify.breakpoint.smAndDown"
      :src="logoSrc"
      contain
      :max-height="220"
      :max-width="220"
      class="mr-5"
      alt="Logo"
    />

    <!-- Titre (desktop uniquement) -->
    <v-toolbar-title
      v-if="!$vuetify.breakpoint.smAndDown"
      class="ml-5 desktop-title text-truncate"
      style="min-width:0;"
    >
      <span class="text-h6 font-weight-bold">
        {{ company.name }}
      </span>
      <span v-if="department"> | {{ department.name }}</span>
      <span> | {{ title }}</span>
    </v-toolbar-title>

    <v-spacer />

    <!-- Bouton nouvelle version (cache sur mobile) -->
    <v-btn
      v-if="newVersionUrl && !$vuetify.breakpoint.smAndDown"
      :href="newVersionUrl"
      target="_blank"
      small
      color="primary"
      class="mr-2 text-none"
      depressed
    >
      <v-icon small left>mdi-open-in-new</v-icon>
      Tester la nouvelle version
    </v-btn>

    <!-- Boutons d’action (déjà masqués en XS) -->
    <v-btn
      v-if="!$vuetify.breakpoint.xs"
      icon
      @click="goToDepartment"
      class="mr-2"
      :title="$t('Accueil des départements')"
    >
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn
      v-if="$store.getters['app/isUserStaff'] && !$vuetify.breakpoint.xs"
      :title="$t('Administration')"
      class="mr-2"
      icon
      @click="goToAdmin"
    >
      <v-icon>mdi-security</v-icon>
    </v-btn>

    <ThemeSwitch v-if="!$vuetify.breakpoint.xs" />

    <!-- 🔒 Masqués en mobile -->
    <NotificationButton v-if="!$vuetify.breakpoint.smAndDown" />
    <v-divider v-if="!$vuetify.breakpoint.smAndDown" class="ml-1" vertical />
    <LanguagesSwitch v-if="!$vuetify.breakpoint.smAndDown" />

    <UserProfileButton />
  </v-app-bar>

</template>

<script>
import { getTheme } from "@/plugins/vuetify"

export default {
  name: "AppBar",
  components: {
    LanguagesSwitch: () => import("@/components/inputs/LanguagesSwitch.vue"),
    NotificationButton: () => import("@/components/generics/buttons/NotificationButton.vue"),
    ThemeSwitch: () => import("@/components/inputs/ThemeSwitch.vue"),
    UserProfileButton: () => import("@/components/generics/buttons/UserProfileButton.vue")
  },
  computed: {
    color() {
      return getTheme(this).bgAppBar
    },
    isThemeDark() {
      return this.$store.state.app.isThemeDark
    },
    // Source du logo selon le thème
    logoSrc() {
      return this.isThemeDark
        ? this.$appConfig.assets.img.custom.logo_white
        : this.$appConfig.assets.img.custom.logo
    },
    logoMobileSrc() {
      return this.isThemeDark
        ? this.$appConfig.assets.img.custom.icon_logo_white
        : this.$appConfig.assets.img.custom.icon_logo
    },
    title() {
      return this.$t(`nav.title.${this.$route.name}`)
    },
    company() {
      return this.$store.state.app.company
    },
    department() {
      return this.$store.state.app.project
    },
    newVersionUrl() {
      return process.env.VUE_APP_NEW_VERSION_URL || "https://new.gwassou.com"
    }
  },
  methods: {
    goToDepartment() {
      if (this.$store.state.app.project) this.$store.commit("app/clearProject");
      this.$router.push({ name: "MainDepartment" })
    },
    goToAdmin() {
      this.$router.push({ name: "Admin" })
    },
    onMenuClicked() {
      this.$emit("toggleMobile")
    }
  }
}
</script>

<style scoped>
#app-navbar {
  border-color: grey;
}

.mobile-title {
  margin-left: 0 !important;
  font-size: 0.875rem !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}

.desktop-title {
  margin-left: 30px !important;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .mobile-title {
    max-width: 120px;
  }
}
</style>